import React from 'react';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import VirtualList from 'react-tiny-virtual-list';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Tooltip from '../../../../../components/Tooltip';
import RateInput from '../RateInput';

import * as helpers from '../../helpers';

const List = ({ filteredRates, values, onChangeCheck, onChangeType, onChangeRatesValue, config }) => {
  const checkTitle = (categoryId) => {
    const fullRateByCategory = filteredRates
      .filter((item) => Number(item.category_id) === Number(categoryId) && !item.itCategory)
      .map((item) => item.custom_id);
    if (fullRateByCategory.every((v) => values.includes(v))) {
      return true;
    }
    return false;
  };

  const maxDecimals = helpers.countDecimals(Number(config?.min_service_rate));

  const prepareConvertedPrice = (price) => {
    if (price === 0) {
      return '0.00';
    }

    const decimals = helpers.countDecimals(price);
    const fixedPrice = decimals > 2 ? Number(price.toFixed(maxDecimals)) : Number(price).toFixed(2);
    const prepareConverted = config?.min_service_rate > fixedPrice ? config?.min_service_rate : fixedPrice;
    return prepareConverted;
  };

  return (
    <AutoSizer>
      {({ height, width }) => (
        <VirtualList
          width={width}
          height={height - 46}
          itemCount={filteredRates?.length}
          itemSize={50}
          className="rates-container"
          renderItem={({ index, style }) => {
            const elem = filteredRates[index];
            const isConverted = helpers.detectConvertedRate(elem.converted, elem.provider_rate, elem.provider_rate_origin);
            const convertedPrice = prepareConvertedPrice(elem.converted_price);

            if (elem.itCategory) {
              return (
                <div key={index} style={style} className="table-category">
                  <Table className="table-rate__item">
                    <tbody>
                      <tr style={{ height: style.height }} className={checkTitle(elem.category_id) ? 'active' : ''}>
                        <td>
                          <input
                            className="input__check"
                            type="checkbox"
                            disabled={false}
                            onChange={(e) => onChangeCheck(e, { title: elem.category_name, id: elem.category_id }, true)}
                            checked={checkTitle(elem.category_id)}
                            value={values}
                          />
                        </td>
                        <td colSpan={3} className="user-rates__table-category">
                          {elem.category_name}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              );
            }

            return (
              <div key={index} style={style} className="table-rate">
                <Table className="table-rate__item">
                  <tbody>
                    <tr style={{ height: style.height }} className={values.includes(elem.custom_id) ? 'active' : ''}>
                      <td>
                        <input
                          className="input__check"
                          type="checkbox"
                          disabled={false}
                          onChange={(e) => onChangeCheck(e, elem)}
                          checked={values?.includes(elem.custom_id)}
                          value={values}
                        />
                      </td>
                      <td className="table-services">
                        <div className="item__selected-info">
                          <span className="item__id">{elem.service_id}</span>
                          <div className="item__rates-name">{elem.service_name}</div>
                        </div>
                      </td>
                      <td className="service-rate">
                        <div>{elem.price}</div>
                        <>
                          {isConverted === 'converted' ? (
                            <Tooltip
                              text={`${elem.provider_rate_origin}${elem.currency ? ` ${elem.currency}` : ''}`}
                              placement="left"
                              tooltipClass="tooltip__left"
                            >
                              <span className="rates-provider-value">
                                ≈
                                {' '}
                                {Number.isNaN(elem?.provider_rate) ? '' : elem?.provider_rate}
                              </span>
                            </Tooltip>
                          ) : isConverted === 'not-converted' ? (
                            <span className="rates-provider-value">
                              {Number.isNaN(elem?.provider_rate) ? '' : Number(elem?.provider_rate)}
                            </span>
                          ) : null}
                        </>
                      </td>
                      <td className="table-rate">
                        <div className="user-rates__custom-prices">
                          <div className={elem.provider_rate && Number(elem.converted_price) < Number(elem.provider_rate) ? 'rate-danger' : ''}>
                            {convertedPrice}
                          </div>
                          <RateInput
                            value={elem.custom_price}
                            originalValue={elem.price}
                            valueType={elem.percent}
                            onChangeType={(type, value) => onChangeType(type, value, elem.custom_id)}
                            onChangeValue={(value) => onChangeRatesValue(value, elem.custom_id)}
                            name="custom_rates"
                            currency={config?.panel}
                            dropup={!!(index > 12 && filteredRates.length - 1 === index)}
                            config={config}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            );
          }}
        />
      )}
    </AutoSizer>
  );
};

List.propTypes = {
  filteredRates: PropTypes.array,
  values: PropTypes.array,
  onChangeCheck: PropTypes.func,
  onChangeType: PropTypes.func,
  onChangeRatesValue: PropTypes.func,
  config: PropTypes.object,
};

export default List;
